// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { mergeWithCss } from "@pace/XDL/Utilities";
import React, { useState } from "react";

export interface ReplacementLinkStyles {
    replacementLink?: LinkPresentationProps;
}

type Props = {
    replacementProductJson: string | ProductDto | null;
    isWishListDetailsPage?: boolean;
};

export const replacementLinkStyles: ReplacementLinkStyles = {};
const styles = replacementLinkStyles;
const ReplacementLink = ({ replacementProductJson, isWishListDetailsPage = false }: Props) => {
    if (!replacementProductJson) {
        return null;
    }

    let replacementProductUrl: string | null = null;
    if (isWishListDetailsPage) {
        replacementProductUrl = (replacementProductJson as ProductDto).productDetailUrl;
    } else {
        const parsed = JSON.parse(replacementProductJson as string);
        replacementProductUrl = parsed?.productUrl || null;
        if (!replacementProductUrl) {
            return null;
        }
    }

    return (
        <Link {...styles.replacementLink} href={replacementProductUrl} className="replacment-link">
            {translate("[Replacement Item Available]")}
        </Link>
    );
};

export default ReplacementLink;
